module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.rowData.siteId,
    staticClass: "padded"
  }, [_c('h3', [_vm._v(_vm._s(_vm.utilLabel) + " Bill Details")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.canAccess('finance') ? 12 : 20
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.formatDate(_vm.rowData.date)))]), _vm._v(" "), (_vm.showTax(_vm.isUtilTaxable)) ? _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.taxLabel))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v("Invoice No.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowData.invoiceNo))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Period")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.rowData.periodFrom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.rowData.periodTo)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.overdueLabel))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.arrears)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.amountLabel))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.amount)))]), _vm._v(" "), (_vm.showTax(_vm.isUtilTaxable)) ? _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.tax)))]) : _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Penalties")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.penalty)))]), _vm._v(" "), _c('td')]), _vm._v(" "), (_vm.showTax(_vm.isUtilTaxable)) ? _c('tr', [_c('th', [_vm._v("Un-taxed charges")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.untaxedCharges)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.extraChargesLabel))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.extraCharges)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Rounding Adjustment")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.rounding)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.total)))]), _vm._v(" "), (_vm.showTax(_vm.isUtilTaxable)) ? _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.rowData.tax)))]) : _c('td')])])])]), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 10,
      "offset": 2
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('tr', [_c('th', [_vm._v("Paid?")]), _vm._v(" "), (!_vm.rowData.paid) ? _c('td', [_c('switch-input', {
    attrs: {
      "on-text": "Yes",
      "off-text": "No"
    },
    on: {
      "change": _vm.onPaid
    },
    model: {
      value: (_vm.form.paid),
      callback: function($$v) {
        _vm.$set(_vm.form, "paid", $$v)
      },
      expression: "form.paid"
    }
  })], 1) : _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "text-success"
  }, [_vm._v("Yes")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), (!_vm.rowData.paid) ? _c('td', [_c('date-input', {
    attrs: {
      "placeholder": "Paid Date",
      "disabled": !_vm.form.paid
    },
    model: {
      value: (_vm.form.paidDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "paidDate", $$v)
      },
      expression: "form.paidDate"
    }
  })], 1) : _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.formatDate(this.rowData.paidDate)))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ref")]), _vm._v(" "), (!_vm.rowData.paid) ? _c('td', [_c('text-input', {
    attrs: {
      "placeholder": "Paid Ref",
      "disabled": !_vm.form.paid
    },
    model: {
      value: (_vm.form.paidRef),
      callback: function($$v) {
        _vm.$set(_vm.form, "paidRef", $$v)
      },
      expression: "form.paidRef"
    }
  })], 1) : _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.rowData.paidRef))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Amount")]), _vm._v(" "), (!_vm.rowData.paid) ? _c('td', [_c('currency-input', {
    attrs: {
      "disabled": !_vm.form.paid
    },
    model: {
      value: (_vm.form.amountPaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "amountPaid", $$v)
      },
      expression: "form.amountPaid"
    }
  })], 1) : _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.formatNumber(this.rowData.amountPaid)))])])]), _vm._v(" "), (_vm.showTax(_vm.isUtilTaxable) && (_vm.form.taxPaid && _vm.form.taxPaid > 0)) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.taxLabel))]), _vm._v(" "), (!_vm.rowData.paid) ? _c('td', [_c('currency-input', {
    attrs: {
      "disabled": !_vm.form.paid
    },
    model: {
      value: (_vm.form.taxPaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "taxPaid", $$v)
      },
      expression: "form.taxPaid"
    }
  }), _vm._v(" "), (!_vm.paidSubmit && !_vm.rowData.paid) ? _c('span', [_vm._v(_vm._s(_vm.tax))]) : _vm._e()], 1) : _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.formatNumber(this.rowData.taxPaid)))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n               " + _vm._s(_vm.currency)), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.totalPaid)))])])]), _vm._v(" "), (_vm.outstanding && _vm.outstanding !== '0.00') ? _c('tr', [_c('th', [_vm._v("O/S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.outstanding))])])]) : _vm._e(), _vm._v(" "), (!_vm.paidSubmit && !_vm.rowData.paid) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.payable && !_vm.paidSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")])], 1)]) : _vm._e()])])], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('utility-sharing-table', {
    attrs: {
      "row-data": _vm.rowData,
      "site": _vm.site
    }
  })], 1), _vm._v(" "), (_vm.rowData && _vm.rowData.updated_at) ? _c('el-col', {
    attrs: {
      "align": "right",
      "span": 24
    }
  }, [_c('small', [_vm._v("Last Update ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.rowData.updated_at)))]), (_vm.rowData.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.rowData.updated_by))]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62978781"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilityDetail.vue
// module id = 1601
// module chunks = 0